<template>
  <div class="page-shell page-shell--deliver-tenant">
    <section class="page-shell__content">
      <div class="page-shell__panel">
        <public-table
          :column="column"
          :tableData="dataList"
          :PageInfo="listQuery"
          :enableSearch="true"
          :searchItems="searchItems"
          @handlePaginationChange="handleSearchList"
          :is_table="true"
        >
          <template v-slot:createTime="{ row }">{{
            row.createTime ? timetrans(row.createTime) : '-'
          }}</template>
          <template v-slot:updateTime="{ row }">{{
            row.updateTime ? timetrans(row.updateTime) : '-'
          }}</template>
          <template v-slot:tenantID="{ row }">
            <el-button size="mini" type="text" @click="toPaaS(row)">
              <a :href="row.tenantURL" target="_blank">高级运维</a>
            </el-button>
          </template>
        </public-table>
      </div>
    </section>
  </div>
</template>
<script>
import {
  fetchDeliveryRegionList,
  getDeliveryTenantsListApi
} from '@/api/delivery';
import { handleRegion } from '@/utils/common';
import { errorHandle } from '@/utils/error';
import { timetrans } from '@/utils/validate';
export default {
  name: 'TenantManage',
  data() {
    return {
      timetrans,
      isperform: true,
      Loading: false,
      dataList: [],
      listQuery: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      column: [
        {
          prop: 'tenantAlias',
          label: '租户名称'
        },
        {
          prop: 'customerName',
          label: '客户名称'
        },
        {
          prop: 'regionAlias',
          label: '交付环境'
        },
        {
          prop: 'deliveryAppNum',
          label: '交付应用数量'
        },
        {
          prop: 'usedMemory',
          label: '使用内存(MB)'
        },
        {
          prop: 'createTime',
          label: '创建时间',
          width: '150px',
          scopeStatus: true
        },
        {
          prop: 'updateTime',
          label: '更新时间',
          width: '150px',
          scopeStatus: true
        },
        {
          prop: 'tenantID',
          label: '操作',
          scopeStatus: true
        }
      ],
      searchItems: [
        {
          label: '租户名称',
          name: 'query',
          value: '',
          span: 8,
          type: 'input'
        },
        {
          label: '客户名称',
          name: 'customerID',
          value: '',
          span: 8,
          type: 'select',
          options: []
        },
        {
          label: '交付环境',
          name: 'regionID',
          value: '',
          span: 8,
          type: 'selectgroup',
          options: []
        }
      ]
    };
  },
  created() {
    this.getDataList();
    this.getDeliverEnvs();
  },
  computed: {
    marketID() {
      return this.$store.state.enterprise.enterpriseInfo.marketID;
    }
  },
  methods: {
    handleSearchList(data) {
      this.listQuery.page = 1;
      data = data || {};
      this.listQuery = { ...this.listQuery, ...data };
      this.getDataList();
    },
    getDataList() {
      this.listQuery.marketID = this.marketID;
      getDeliveryTenantsListApi(this.listQuery)
        .then((res) => {
          if (res) {
            this.dataList = res.tenants || [];
            if (res.tenants && res.tenants.length > 0) {
              this.searchItems.map((item) => {
                if (item.name == 'customerID' && this.isperform) {
                  let arr = res.tenants.map((item) => {
                    return { label: item.customerName, value: item.customerID };
                  });
                  const hash = {};
                  arr = arr.reduce(function(item, next) {
                    hash[next.value]
                      ? ''
                      : (hash[next.value] = true && item.push(next));
                    return item;
                  }, []);
                  arr.unshift({
                    label: '全部',
                    value: ''
                  });
                  item.options = arr || [];
                  this.isperform = false;
                }
              });
            }
            this.listQuery.total = res.total;
          }
        })
        .catch((err) => {
          errorHandle(err);
        });
    },
    getDeliverEnvs() {
      fetchDeliveryRegionList({
        marketID: this.marketID,
        page: -1,
        pageSize: -1
      })
        .then((res) => {
          if (res) {
            if (res.regions) {
              const regionOptions = handleRegion(res.regions);
              this.searchItems.map((item) => {
                if (item.name == 'regionID') {
                  item.options = regionOptions;
                }
              });
            } else {
              this.deliveryRegions = [];
            }
          }
        })
        .catch((err) => {
          errorHandle(err);
        });
    },
    toPaaS(row) {
      // TODO
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/styles/page-shell.scss';
</style>



// WEBPACK FOOTER //
// src/views/deliverManage/tenant/index.vue